import {SponsorCartRequest} from "./SponsorCartResponse";

export interface OfferCartRequest {
    readonly id: string;
    readonly device?: string | null;
    readonly mobileId?: string | null;
    readonly sponsorCartRequest?: SponsorCartRequest | null;
    readonly universe: OfferUniverse;
    readonly needDevice?: boolean;
}

export enum OfferUniverse {
    INTERNET = 'INTERNET',
    MOBILE = 'MOBILE'
}

export type OfferCartResponse =
        | OfferCartResponseSuccess
        | OfferCartResponseNeedConfirmation
        | OfferCartResponseError;

export interface OfferCartResponseSuccess {
    readonly type: 'success';
    readonly redirectUrl: string;
}

export interface OfferCartResponseNeedConfirmation {
    readonly type: 'needConfirmation';
    readonly parameters: Readonly<Record<string, string>>;
    readonly message?: MessageDto | null;
}

export interface OfferCartResponseError {
    readonly type: 'error';
    readonly redirectUrl: string;
}

export interface MessageDto {
    readonly title: string;
    readonly text: string;
    readonly buttonLabel: string;
}
